export default class Convocatory{

  constructor(){
    this.name = null;
    this.code = null;
    this.program = null;
    this.group = null;
    this.description = null;
    this.objective = null;
    this.competencies = null;
    this.quota = null;
    this.request = null;
    this.date_begin = null;
    this.date_end = null;
    this.date_inscription = null;
    this.state = null;
  }

}